/**
 * Хранилище модуля Layout
 * @module Layout/Store
 * @requires Vuex
 * @requires Vue
 * @requires Layout
 * */

import Vue from 'vue'
import Vuex from 'vuex'
import { LocalStorage } from 'quasar'

Vue.use(Vuex)

const defaultState = () => ({
  /**
   * Отображение десктопного бокового меню
   * @type Boolean
   * */
  isShowMenu: true,
  /**
   * Список пунктов бокового десктопного меню
   * @type Array.<String>
   * */
  menu: []
})

export default new Vuex.Store({
  state: defaultState(),
  mutations: {
    /**
     * Универсальное обновление state Хранилища
     * @function
     * @param {Object} state
     * @param {Object} patch
     * @param {String} patch.name
     * @param {*} patch.value
     * */
    setState(state, patch) {
      if (!patch.name) throw new Error('name required')
      if (patch.value === undefined) throw new Error('value required')

      Vue.set(state, patch.name, patch.value)
    },

    /**
     * Выборка пунктов меню из конфига
     * @function
     * @param {Object} state
     * */
    setMenu(state) {
      const module = new Module()
      const menu = []
      const userRole = LocalStorage.getItem('userRole')
      Object.keys(module.$$config.modules).forEach((k) => {
        const page = module.$$config.modules[k]
        if (page.inMenu && page.roles.includes(userRole)) {
          menu.push({
            id: k,
            title: page.title,
            icon: page.icon,
            url: `/${k}`
          })
        }
      })

      Vue.set(state, 'menu', menu)
    }
  }
})
